import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { DialogService } from 'app-shared-ui';
import { LoginComponent } from '../accounts/login/login.component';
import { CacheService } from '../services';
import { Router } from '@angular/router';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private readonly _cacheService: CacheService,
    private readonly _dialogService: DialogService,
    private readonly _router: Router,
  ) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        const loginUrl = request.url.includes('auth/login');
        if (loginUrl) {
          return next.handle(request);
        } else {
          if (error.status === 401) {
            this._cacheService.clear();
            this._router.navigate(['home'], { queryParamsHandling: 'preserve' });
            setTimeout(() => {
              window.location.reload();
            }, 200);
            setTimeout(() => {
              // Unauthorized, navigate to login screen
              this._dialogService.openDialog({
                component: LoginComponent
              });
            }, 1000);
          }

          if (error.status === 406) {
            this._router.navigate(['/account/user/verify'], { queryParamsHandling: 'preserve' });
          }
        }
        return throwError(error);
      })
    );
  }
}
